import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { useTranslation } from 'react-i18next';
import UseScrollAnimation from "../../hooks/UseScrollAnimation";
import axios from "axios";

export default function MainCategories() {
  const { t, i18n } = useTranslation();
  UseScrollAnimation();

  const [, setDataSubCategory] = useState([]);
  const [filteredSubCategories, setFilteredSubCategories] = useState([]);

  const getLocalizedText = (key) => {
    return i18n.language === 'ar' ? key.A : key.E;
  };

  useEffect(() => {
    const path = window.location.pathname;
    const lastWordEncoded = path.substring(path.lastIndexOf("/") + 1);
    const lastWordDecoded = decodeURIComponent(lastWordEncoded);

    const fetchData = async () => {
      try {
        const response = await axios.get("https://laravel-api.aj-mart.com/api/subCategory");
        const subCategories = response.data.sub_category;
        setDataSubCategory(subCategories);

        const filtered = subCategories.filter(
          (subCat) => subCat.sub_category_main_name === lastWordDecoded
        );
        setFilteredSubCategories(filtered);
      } catch (error) {
        console.error("Error When Fetching Data:", error);
      }
    };
    fetchData();
  }, []);

  const path = window.location.pathname;
  const lastWordEncoded = path.substring(path.lastIndexOf("/") + 1);
  const lastWordDecoded = decodeURIComponent(lastWordEncoded);

  const encodedMain = encodeURIComponent(lastWordDecoded || "");
  console.log("Encoded Main Category:", encodedMain);

  return (
    <>
      <section className="landingPages">
        <div className="container h-full flex flex-col gap-[10px] justify-center">
          <div className="btmAni30002 text-[35px] font-bold text-white">
            {t("Main Categories")}
          </div>
          <div className="btmAni25002 flex items-center gap-[3px] text-white">
            <Link to={"/"}>{t("Home")}</Link>
            <span>-</span>
            <div>{lastWordDecoded || t("Main Categories")}</div>
          </div>
        </div>
      </section>

      <section className="relative py-[40px]">
        <div className="container flex flex-col gap-[30px]">
          <h2 className="text-2xl font-bold">{t("Sub Categories")}</h2>

          {/* Grid */}
          <div className="flex items-center flex-wrap gap-[15px]">

            {/* --- ALL tile (نفس ستايل الكروت) --- */}
            <Link
              to={`/subCategories/${encodedMain}/0`}
              className="flex flex-col items-center text-center"
            >
              <div className="back-category w-[125px] h-[125px] shadow-[0px_0px_10px_#0000000f] p-1.5 rounded-md flex items-center justify-center">
                {/* مربع بنفس الأبعاد مع نص All */}
                <div className="w-[115px] h-[115px] rounded-md border border-[#1485a6] flex items-center justify-center">
                  <span className="text-[#ffffff] font-bold text-[18px]">
                    {t("All")}
                  </span>
                </div>
              </div>
              <div className="mt-1">{t("All")}</div>
            </Link>

            {/* --- Subcategory tiles --- */}
            {filteredSubCategories.length > 0 ? (
              filteredSubCategories.map((subCat) => {
                const localizedSubCategoryName = getLocalizedText({
                  A: subCat.sub_category_name_A,
                  E: subCat.sub_category_name_E,
                });
                const urlFriendlyName = localizedSubCategoryName.replace(/\s+/g, " ");
                const localizedAltText = localizedSubCategoryName;

                return (
                  <Link
                    key={subCat.sub_category_id}
                    to={`/subCategories/${encodedMain}/${encodeURIComponent(urlFriendlyName)}`}
                    className="flex flex-col items-center text-center"
                  >
                    <div className="back-category w-[125px] h-[125px] shadow-[0px_0px_10px_#0000000f] p-1.5 rounded-md flex items-center justify-center">
                      <img
                        className="w-[125px] h-[125px] object-contain"
                        src={`https://laravel-api.aj-mart.com/storage/app/public/${subCat.sub_category_img}`}
                        alt={localizedAltText}
                      />
                    </div>
                    <div className="mt-1">{localizedSubCategoryName}</div>
                  </Link>
                );
              })
            ) : null}
          </div>

          {filteredSubCategories.length === 0 && (
            <p className="text-gray-500">{t("No subcategories found")}</p>
          )}
        </div>
      </section>
    </>
  );
}
